import { create } from "zustand";

/**
 * Звучит ли карточка сигнала. Общее на вкладку.
 *
 * # Почему включено по умолчанию
 *
 * Карточка живёт две минуты и приходит по окну, на которое оператор в этот
 * момент не смотрит. Молчащая по умолчанию она означала бы, что первый же
 * сигнал будет пропущен ровно у того, кто настройку ещё не нашёл.
 *
 * # Почему БЕЗ записи в localStorage
 *
 * То же решение, что у выбранного окна статистики (useFlowWindow), и по более
 * весомой причине: сохранённое «выключено» — это молчание в новой вкладке, о
 * котором оператор не вспомнит. Забытый вчера переключатель стоил бы
 * пропущенной ставки, а лишний звук стоит одного клика.
 *
 * Настройки оператора (lib/settings.ts) лежат ОДНИМ ключом ради согласованности
 * набора; второй ключ рядом с ним завёл бы вторую дисциплину хранения ради
 * переключателя, который переживать перезагрузку и не должен.
 */
interface SignalSoundStore {
  on: boolean;
  toggle: () => void;
}

export const useSignalSound = create<SignalSoundStore>((set) => ({
  on: true,
  toggle: () => set((s) => ({ on: !s.on })),
}));
